<div  class="popup-overlay">
  <div class="modal-content popup">
    <span class="close-button" (click)="submitDateTime(false)">×</span>
    <h3 class="message">Enter Start Date and Time(UTC)</h3>
    <div class="content">
      <label class="radio-label">
        Start Date:
        <input type="date" [(ngModel)]="startDate"  />
      </label>
      <br />
      <label class="radio-label">
        Start Time:
        <input type="time" [(ngModel)]="startTime" />
      </label>
    </div>
    <div class="btn row">
      <button class="hover-clear" (click)="submitDateTime(true)">Submit</button>
      <button class="hover-clear" (click)="submitDateTime(false)">Cancel</button>
    </div>
  </div>
</div>
